/**
 * @class Helper
 * Helper functions that are used throughout the platform.
 */

import API from './API';
import APIHelper from './APIHelper';
import AuthUser, { AuthUserType } from './AuthUser';

declare let window: any;

//====================================================================

export const GetAuthRoutes = () => {
  return [
    {
      path: '/passback',
      name: 'passback',
      meta: {
        noAuthRequired: true,
      },
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        noAuthRequired: true,
      },
    },
  ];
};

export const RouterBeforeEach = (to: any, from: any, next: any = () => {}) =>
  new Promise(async (resolve) => {
    if (to.name === 'passback') {
      //Handle auth callback
      await APIHelper.handleCallback(to);
    } else if (to.name === 'logout') {
      //Handle auth callback
      await APIHelper.handleLogout();
      window.location.href = 'https://archistar.ai';

      if (window.Appcues) window.Appcues.page();
      resolve(1);
      next();
    } else if (
      // Auth route
      !to.meta.hasOwnProperty('noAuthRequired') ||
      !to.meta.noAuthRequired
    ) {

      if (to.query.jwt) {
        // Token present - use once & continue on
        APIHelper.AuthAPIs.forEach((itApi: API) => {
          itApi.setHeaderCommons('Authorization', 'Bearer ' + to.query.jwt);
        });
        if (!AuthUser.exists()) await AuthUser.fetch(to);

        if (window.Appcues) window.Appcues.page();
        resolve(1);
        next();
      } else {
        if (!APIHelper.isUserLoggedIn()) {
          //Redirect for login
          if (!APIHelper.getCurrentRefreshToken()) {
            APIHelper.handleLogin(to);
          }
        } else {
          // Get userinfo if none is present
          if (!AuthUser.exists()) await AuthUser.fetch(to);

          if (window.Appcues) window.Appcues.page();
          resolve(1);
          next();
        }
      }
    } else {
      if (window.Appcues) window.Appcues.page();
      resolve(1);
      next();
    }
  });
  
export const GetFullStoryUserObject = (authUserInfo: AuthUserType) => {
    return {
      // User
      email: authUserInfo.email,
      displayName: authUserInfo.firstName ?? '' + authUserInfo.lastName ?? ''
    };
};
export const GetAppcuesUserObject = (authUserInfo: AuthUserType) => {
  // Get latest subscription by contract_start_date
  const sortedSubs = authUserInfo.subscriptions
    .slice()
    .sort((a: any, b: any) =>
      a.subscription_starts_at < b.subscription_starts_at ? 1 : -1
    ) as any[];
  const latestSubs = (sortedSubs.length > 0 ? sortedSubs[0] : null) as
    | any
    | null;

  const companyNames = authUserInfo?.companies
    // Remove null names
    ?.filter((c: any) => c.name)

    // Extract .name into an arr
    .map((c: any) => c.name)

    // join into parsable string format
    .join(';');

  return {
    // User
    user_email: authUserInfo.email,
    user_first_name: authUserInfo.firstName,
    user_last_name: authUserInfo.lastName,
    user_last_login_date: authUserInfo.lastLogin,
    user_company_names: companyNames,

    // Last Subscription
    subscription_package: latestSubs?.type || null,
    subscription_region_names: latestSubs?.region_names || null,
    subscription_start_date: latestSubs?.subsc_start || null,
    subscription_renewal_date: latestSubs?.subsc_end || null,
    subscription_contract_term: latestSubs?.contract_term_months || null,
    subscription_status: latestSubs?.status || null,
    subscription_is_trial: latestSubs?.is_trial || null,
  };
};

export const GetSentryUserObject = (authUserInfo: AuthUserType) => {
  return {
    email: authUserInfo.email,
    username: authUserInfo.firstName,
  };
};

export const GetActiveCountryCookie = () => {
  return GetCookie('asCountryCode');
};

export const SetCrossSubdomainCookie = (name: string, value: string, days: number) => {
  const assign = name + '=' + escape(value) + ';';
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString() + ';';
  const path = 'path=/;';
  let domain = 'domain=' + window.location.hostname.match(/([^.]+.[^.]+)$/gm) + ';';
  document.cookie = assign + expires + path + domain;
};
export const GetCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};